const f = {
  color: {
    light: {
      error: {
        border: "#fedfd5ff",
        background: "#fff0e8ff",
        text: "#b83525ff"
      },
      info: {
        border: "#d1e8ffff",
        background: "#ebf5ffff",
        text: "#263aadff"
      },
      success: {
        border: "#e0fcdeff",
        background: "#f2fff0ff",
        text: "#222923ff"
      },
      warning: {
        border: "#ffeeccff",
        background: "#fff6e5ff",
        text: "#a35214ff"
      }
    },
    bold: {
      error: {
        border: "#822824ff",
        button: "#822824ff",
        background: "#b83525ff",
        text: "white"
      },
      info: {
        border: "#263aadff",
        button: "#263aadff",
        background: "#304ddbff",
        text: "white"
      },
      success: {
        border: "#28704cff",
        button: "#28704cff",
        background: "#2d8556ff",
        text: "white"
      },
      warning: {
        border: "#7a4518ff",
        button: "#7a4518ff",
        background: "#a35214ff",
        text: "white"
      }
    }
  }
};
export {
  f as statusBar
};
